import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global fetch interceptor for API calls:
// 1. Adds auth token from localStorage (fixes iPad/Safari cookie issues)
// 2. Strips credentials:'include' (prevents cross-origin CORS issues)
const _originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  if (typeof url === 'string' && url.includes('/api/')) {
    // Add auth token from localStorage
    const token = localStorage.getItem('reliefify_session_token');
    const headers = options.headers || {};
    if (token && !headers['Authorization'] && !(headers instanceof Headers && headers.has('Authorization'))) {
      options = { ...options, headers: { ...headers, 'Authorization': `Bearer ${token}` } };
    }
    // Strip credentials:'include' — we use Authorization header instead
    if (options.credentials) {
      const { credentials, ...rest } = options;
      options = rest;
    }
  }
  return _originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
